import {CONTENT_TYPES} from "@/constants";
import {useMemo} from "react";
import useFilterDataByState from "@/hooks/useFilterDataByState";
import {getItemType} from "@/utils/utils";

export default function useSetBannerData(data) {
	const content = data?.content || []
	const contextBasedBannersData = data?.contextBasedBanners || []
	const filteredByStateData = useFilterDataByState(contextBasedBannersData)

	const globalBasedBanner = useMemo(() => {
		return content.filter((item) => getItemType(item) === CONTENT_TYPES.GLOBAL_BASED_BANNER)
	}, [content, data])

	if (filteredByStateData) return filteredByStateData
	if (globalBasedBanner.length > 0) return globalBasedBanner[0]

	return null
}

export function useSetBannerDataFromRecapContent(data) {
	const content = data?.content || []
	const contextBasedBannersData = data?.contextBasedBanners || []
	const filteredByStateData = useFilterDataByState(contextBasedBannersData)

	const globalBasedBanner = useMemo(() => {
		return content.filter((item) => getItemType(item?.item) === CONTENT_TYPES.GLOBAL_BASED_BANNER)
	}, [content, data])

	if (filteredByStateData) return filteredByStateData
	if (globalBasedBanner.length > 0) return globalBasedBanner[0].item

	return null
}
